var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "styles-outer-container" }, [
    _c("div", { staticClass: "styles-inner-container" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", { staticClass: "font-weight-bold text-white" }, [
          _c("div", { staticClass: "d-inline-flex align-items-center" }, [
            _c("span", { staticClass: "badge bg-gray-light text-normal" }, [
              _vm._v(_vm._s(_vm._f("trans")("FREE"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted font-weight-bold" }, [
          _vm._v(_vm._s(_vm._f("trans")("Free to use"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center style-select-container" },
        _vm._l(_vm.styles_basic, function (style) {
          return _c(
            "div",
            {
              staticClass: "style-card",
              class: {
                active:
                  _vm.creatorStudio.settings.conversion.options.style ===
                  style.conversion_style,
              },
              on: {
                click: function ($event) {
                  return _vm.changeStyle(style.conversion_style)
                },
              },
            },
            [
              _c("div", { staticClass: "img-container" }, [
                _c("img", {
                  attrs: {
                    alt: style.name,
                    srcset: `${style.path["1x"]} 1x,  ${style.path["2x"]} 2x, ${style.path["3x"]} 3x,  ${style.path["4x"]} 4x`,
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "style-name d-flex justify-content-between" },
                [
                  _vm._v(_vm._s(_vm._f("trans")(style.name)) + " "),
                  style.unrestricted === true
                    ? _c(
                        "span",
                        {
                          staticClass: "lh-inherit badge badge-info",
                          attrs: {
                            "data-toggle": "tooltip",
                            title: _vm.tooltip_unassisted,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "lh-inherit far fa-info-circle",
                          }),
                          _vm._v(" PREVIEW"),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkmark-box",
                  class: {
                    active:
                      _vm.creatorStudio.settings.conversion.options.style ===
                      style.conversion_style,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeStyle(style.conversion_style)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-check" })]
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "styles-inner-container" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", { staticClass: "font-weight-bold text-white" }, [
          _c("div", { staticClass: "d-inline-flex align-items-center" }, [
            _vm.isLegacyUser === true
              ? _c("span", { staticClass: "badge badge-starter" }, [
                  _vm._v(_vm._s(_vm._f("trans")("STARTER"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLegacyUser === false
              ? _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v(_vm._s(_vm._f("trans")("PREMIUM EASY"))),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted font-weight-bold" }, [
          _vm._v(_vm._s(_vm._f("trans")("Requires Subscription"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center style-select-container" },
        _vm._l(_vm.styles_starter, function (style) {
          return _c(
            "div",
            {
              staticClass: "style-card",
              class: {
                active:
                  _vm.creatorStudio.settings.conversion.options.style ===
                  style.conversion_style,
              },
              on: {
                click: function ($event) {
                  return _vm.changeStyleStarter(style.conversion_style)
                },
              },
            },
            [
              _c("div", { staticClass: "img-container" }, [
                _c("img", {
                  attrs: {
                    alt: style.name,
                    srcset: `${style.path["1x"]} 1x,  ${style.path["2x"]} 2x, ${style.path["3x"]} 3x,  ${style.path["4x"]} 4x`,
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "style-name d-flex justify-content-between" },
                [
                  _vm._v(_vm._s(_vm._f("trans")(style.name)) + " "),
                  style.nsfw === true
                    ? _c(
                        "span",
                        {
                          staticClass: "lh-inherit badge badge-danger",
                          attrs: {
                            "data-toggle": "tooltip",
                            title: _vm.tooltip_nsfw,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "lh-inherit far fa-info-circle",
                          }),
                          _vm._v(" NSFW"),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkmark-box",
                  class: {
                    active:
                      _vm.creatorStudio.settings.conversion.options.style ===
                      style.conversion_style,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeStyleStarter(style.conversion_style)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-check" })]
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "styles-inner-container" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", { staticClass: "font-weight-bold text-white" }, [
          _c("div", { staticClass: "d-inline-flex align-items-center" }, [
            _vm.isLegacyUser === true
              ? _c("span", { staticClass: "badge badge-pro" }, [
                  _vm._v(_vm._s(_vm._f("trans")("PRO"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLegacyUser === false
              ? _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v(_vm._s(_vm._f("trans")("PREMIUM ADVANCED"))),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted font-weight-bold" }, [
          _vm._v(_vm._s(_vm._f("trans")("Requires Subscription"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center style-select-container" },
        _vm._l(_vm.styles_pro, function (style) {
          return _c(
            "div",
            {
              staticClass: "style-card",
              class: {
                active:
                  _vm.creatorStudio.settings.conversion.options.style ===
                  style.conversion_style,
              },
              on: {
                click: function ($event) {
                  return _vm.changeStylePro(style.conversion_style)
                },
              },
            },
            [
              _c("div", { staticClass: "img-container" }, [
                _c("img", {
                  attrs: {
                    alt: style.name,
                    srcset: `${style.path["1x"]} 1x,  ${style.path["2x"]} 2x, ${style.path["3x"]} 3x,  ${style.path["4x"]} 4x`,
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "style-name" }, [
                _vm._v(_vm._s(_vm._f("trans")(style.name))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkmark-box",
                  class: {
                    active:
                      _vm.creatorStudio.settings.conversion.options.style ===
                      style.conversion_style,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeStylePro(style.conversion_style)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-check" })]
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "styles-inner-container" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", { staticClass: "font-weight-bold text-white" }, [
          _c("div", { staticClass: "d-inline-flex align-items-center" }, [
            _vm.isLegacyUser === true
              ? _c("span", { staticClass: "badge badge-ultimate" }, [
                  _vm._v(_vm._s(_vm._f("trans")("ULTIMATE"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLegacyUser === false
              ? _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v(_vm._s(_vm._f("trans")("PREMIUM EXPERT"))),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted font-weight-bold" }, [
          _vm._v(_vm._s(_vm._f("trans")("Requires Subscription"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center style-select-container" },
        _vm._l(_vm.styles_ultimate, function (style) {
          return _c(
            "div",
            {
              staticClass: "style-card",
              class: {
                active:
                  _vm.creatorStudio.settings.conversion.options.style ===
                  style.conversion_style,
              },
              on: {
                click: function ($event) {
                  return _vm.changeStyleUltimate(style.conversion_style)
                },
              },
            },
            [
              _c("div", { staticClass: "img-container" }, [
                _c("img", {
                  attrs: {
                    alt: style.name,
                    srcset: `${style.path["1x"]} 1x,  ${style.path["2x"]} 2x, ${style.path["3x"]} 3x,  ${style.path["4x"]} 4x`,
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "style-name d-flex justify-content-between" },
                [
                  _vm._v(_vm._s(_vm._f("trans")(style.name)) + " "),
                  style.unrestricted === true
                    ? _c(
                        "span",
                        {
                          staticClass: "lh-inherit badge badge-light",
                          attrs: {
                            "data-toggle": "tooltip",
                            title: _vm.tooltip_unassisted,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "lh-inherit far fa-info-circle",
                          }),
                          _vm._v(" Unassisted"),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkmark-box",
                  class: {
                    active:
                      _vm.creatorStudio.settings.conversion.options.style ===
                      style.conversion_style,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeStyleUltimate(style.conversion_style)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-check" })]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }